import {Base} from "../Base";
import {Divider, Grid, MenuList} from "@mui/material";
import {useEffect, useState} from "react";
import {GetDisplayDesignList} from "../api/DisplayDesignApi";
import {CreateNewDesignItem, DisplayDesignItem} from "../api/response/DisplayDesign";
import {OwnedDesignItem} from "../components/displayDesign/OwnedDesignItem";
import {DisplayEdit} from "../components/displayDesign/DisplayEdit";
import {StringParam, useQueryParam} from "use-query-params";
import {CreateDesignItem} from "../components/displayDesign/CreateDesignItem";

export const DisplayDesign = () => {
  const [displayDesigns, setDisplayDesigns] = useState<DisplayDesignItem[]>([])
  const [selectingDesign, setSelectingDesign] = useState<DisplayDesignItem>()
  const [selectingId] = useQueryParam("id",StringParam)

  const InitializeDisplayList = async () => {
    const list = await GetDisplayDesignList()
    setDisplayDesigns(list)
  }

  useEffect(() => {
    InitializeDisplayList()
  }, [])

  useEffect(()=>{
    if(selectingId == null || displayDesigns.length === 0) {
      setSelectingDesign(undefined)
    }
    const design = displayDesigns.find(item => item.id === selectingId)
    if(design){
      setSelectingDesign(design)
    }else{
      //新規作成
      setSelectingDesign(CreateNewDesignItem())
    }
  },[selectingId, displayDesigns])

  return <Base>
    <Grid container>
      <Grid md={3} xs={12} item>
        <MenuList>
          作成したデザイン
          <Divider/>
          {displayDesigns.map(item => <OwnedDesignItem key={item.id} displayDesign={item} selected={item.id === selectingId}/>)}
          <CreateDesignItem designs={displayDesigns}/>
        </MenuList>
      </Grid>
      <Grid md={9} xs={12} item>
        {selectingId && selectingDesign &&
        <DisplayEdit originItem={selectingDesign} updateList={InitializeDisplayList}/>
        }
      </Grid>
    </Grid>
  </Base>
}